<template>
  <van-dialog
    v-model="myVisible"
    title="溯源码"
    :show-cancel-button="false"
    :show-confirm-button="false"
    close-on-click-overlay
    @close="hideDialog"
  >
    <div class="primary">
      <div class="qr-box">
        <vue-qr logo-src="./favicon.png" :text="tranceSourceLink" :size="200" :correct-level="1" :margin="0" />
        <div class="footnote">
          长按二维码，保存图片
        </div>
      </div>
      <van-button
        v-clipboard:copy="tranceSourceLink"
        v-clipboard:success="()=>{$toast.success('复制成功!')}"
        class="copy-code"
        block
        native-type="button"
        type="primary"
        round
        @click="hideDialog"
      >
        复制链接
      </van-button>
    </div>
  </van-dialog>
</template>

<script>
import { MOBILE_TRACE_DISPLAY_URL, MOBILE_TRACE_DISPLAY_URL_PACK } from '@/constant/config'

export default {
  name: 'QrTraceDialog',
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    tranceCode: {
      type: String,
      default: ''
    },
    state: {
      type: String,
      default: 'pick'
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      myVisible: false
    }
  },
  computed: {
    tranceSourceLink() {
      const baseURL = this.state === 'pick' ? MOBILE_TRACE_DISPLAY_URL : MOBILE_TRACE_DISPLAY_URL_PACK
      // console.log(baseURL)
      return baseURL + this.tranceCode
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        this.myVisible = newVal
      }
    },
    immediate: true
  },
  methods: {
    hideDialog() {
      this.myVisible = false
      this.$emit('change', this.myVisible)
    }
  }
}
</script>

<style lang='less' scoped>
.primary {
  padding: 20px;
}
.qr-box {
  text-align: center;
  margin-top: 10px;
  .footnote {
    font-size: 14px;
    color: #ccc;
    margin-top: 10px;
  }
}
.copy-code {
  width: 80%;
  margin: 40px auto;

}
</style>
